/* Social proof videos - vanilla JS, sin dependencias (~1KB) */
(function () {
  'use strict';

  function initSection(section) {
    var cards = section.querySelectorAll('[data-sp-video-card]');
    var track = section.querySelector('.sp-videos__track');
    var prevBtn = section.querySelector('.sp-videos__arrow--prev');
    var nextBtn = section.querySelector('.sp-videos__arrow--next');

    function pauseAllExcept(current) {
      cards.forEach(function (card) {
        if (card === current) return;
        var video = card.querySelector('video');
        if (video && !video.paused) {
          video.pause();
        }
        card.classList.remove('is-playing');
      });
    }

    cards.forEach(function (card) {
      var video = card.querySelector('video');
      var playBtn = card.querySelector('.sp-videos__play');
      if (!video || !playBtn) return;

      function play() {
        pauseAllExcept(card);
        card.classList.add('is-playing');
        // El <source> ya está en el DOM; preload="none" evita la descarga
        // hasta este primer play(), que es cuando el navegador empieza a pedir el vídeo.
        video.play().catch(function () {
          /* autoplay bloqueado o formato no soportado: no hacemos nada más */
        });
      }

      playBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        play();
      });

      video.addEventListener('click', function () {
        if (video.paused) {
          play();
        } else {
          video.pause();
        }
      });

      video.addEventListener('pause', function () {
        card.classList.remove('is-playing');
      });

      video.addEventListener('ended', function () {
        card.classList.remove('is-playing');
      });
    });

    function scrollByCard(direction) {
      if (!track) return;
      var card = track.querySelector('.sp-videos__card');
      var amount = card ? card.getBoundingClientRect().width + 16 : 250;
      track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });

    // Arrastrar con el ratón para deslizar en escritorio (sin barra de scroll visible).
    // En móvil/táctil no se activa: el deslizar con el dedo ya funciona de forma nativa.
    if (track) {
      var isDragging = false;
      var dragMoved = false;
      var startX = 0;
      var startScrollLeft = 0;
      var activePointerId = null;

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        isDragging = true;
        dragMoved = false;
        startX = e.clientX;
        startScrollLeft = track.scrollLeft;
        activePointerId = e.pointerId;
        // OJO: no capturamos el puntero aquí. Si lo hiciéramos en cada pulsación,
        // el navegador dejaría de disparar el evento "click" sobre el botón de
        // play (se lo quedaría el track), y los vídeos dejarían de reproducirse.
        // Solo capturamos más abajo, en pointermove, cuando se confirma que es
        // un arrastre real (más de 4px de movimiento).
      });

      track.addEventListener('pointermove', function (e) {
        if (!isDragging) return;
        var dx = e.clientX - startX;
        if (!dragMoved && Math.abs(dx) > 4) {
          dragMoved = true;
          try { track.setPointerCapture(activePointerId); } catch (err) {}
        }
        if (dragMoved) {
          track.scrollLeft = startScrollLeft - dx;
        }
      });

      function endDrag(e) {
        if (dragMoved && e && e.pointerId != null) {
          try { track.releasePointerCapture(e.pointerId); } catch (err) {}
        }
        isDragging = false;
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);

      // Si hubo arrastre real, evita que el clic suelto dispare el play del vídeo.
      track.addEventListener('click', function (e) {
        if (dragMoved) {
          e.stopPropagation();
          e.preventDefault();
        }
        dragMoved = false;
      }, true);
    }
  }

  var SELECTOR = '.sp-videos, .product__video-testimonials';

  document.querySelectorAll(SELECTOR).forEach(initSection);

  // Soporte para el editor de temas de Shopify (secciones/bloques añadidos dinámicamente)
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector(SELECTOR);
    if (section) initSection(section);
  });
})();